import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Job';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $complete = ActionCreator.Async(
  MODULE,
  'Complete',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/job/${id}/complete`, payload)
        .then((response) => {
          dispatch($complete.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $disputed = ActionCreator.Async(
  MODULE,
  'Disputed',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/job/${id}/disputed`, payload)
        .then((response) => {
          dispatch($disputed.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $pod = ActionCreator.Async(MODULE, 'POD', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/job/image`, payload)
      .then((response) => {
        dispatch($pod.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $getPOD = ActionCreator.Async(MODULE, 'Get.POD', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getPOD.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/image`, payload)
      .then((response) => {
        dispatch($getPOD.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getPOD.OPERATION)));
  };
});

export const $deletePOD = ActionCreator.Async(MODULE, 'Delete.POD', (id) => {
  return async (dispatch) => {
    dispatch($processing($deletePOD.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/job/image/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($deletePOD.OPERATION)));
  };
});

export const $summary = ActionCreator.Async(
  MODULE,
  'Get.Summary',
  (payload) => {
    return async (dispatch) => {
      dispatch($processing($summary.OPERATION));

      return await Rest.GET(`${API_URL}/tms/job/summary`, payload)
        .then((response) => {
          dispatch($summary.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($summary.OPERATION)));
    };
  }
);

export const $receive = ActionCreator.Async(
  MODULE,
  'Receive',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/job/${id}/receive`, payload)
        .then((response) => {
          dispatch($receive.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $getJob = ActionCreator.Async(MODULE, 'Get.Shipment', (id) => {
  return async (dispatch) => {
    dispatch($processing($getJob.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/shipment/${id}`)
      .then((response) => {
        dispatch($getJob.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getJob.OPERATION)));
  };
});

export const $getJobByOrder = ActionCreator.Async(MODULE, 'Get.Order', (id) => {
  return async (dispatch) => {
    dispatch($processing($getJobByOrder.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/${id}/order`)
      .then((response) => {
        dispatch($getJobByOrder.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getJobByOrder.OPERATION)));
  };
});
